"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Image_1 = __importDefault(require("stremio/components/Image"));
var Button_1 = __importDefault(require("stremio/components/Button"));
var styles_less_1 = __importDefault(require("./styles.less"));
var Error = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var clearData = react_1.default.useCallback(function () {
        window.localStorage.clear();
        window.location.reload();
    }, []);
    return (react_1.default.createElement("div", { className: styles_less_1.default['error-container'] },
        react_1.default.createElement(Image_1.default, { className: styles_less_1.default['error-image'], src: require('/assets/images/empty.png'), alt: ' ' }),
        react_1.default.createElement("div", { className: styles_less_1.default['info'] },
            react_1.default.createElement("div", { className: styles_less_1.default['title'] }, t('GENERIC_ERROR_MESSAGE')),
            react_1.default.createElement("div", { className: styles_less_1.default['message'] }, t('CAROLINE_RELOAD_HINT', { defaultValue: 'Tenta recarregar a página. Se o problema continuar, volta mais tarde.' }))),
        react_1.default.createElement("div", { className: styles_less_1.default['buttons-container'] },
            react_1.default.createElement(Button_1.default, { className: styles_less_1.default['button-container'], title: t('CLEAR_DATA'), onClick: clearData },
                react_1.default.createElement("div", { className: styles_less_1.default['label'] }, t('CLEAR_DATA'))))));
};
exports.default = Error;
